(() => {
  if (window.__bikezoneBrandAnchorNavLoaded) return;
  window.__bikezoneBrandAnchorNavLoaded = true;

  let resizeObserver;
  let mutationObserver;
  let windowListenersAttached = false;

  const selectors = {
    header: '#SiteHeader',
    navWrapper: '.shopify-section.brand-anchor-nav-wrapper',
    backToTopButton: '.brand-back-to-top'
  };

  function getNavWrapper() {
    const navWrapper = document.querySelector(selectors.navWrapper);
    return navWrapper && navWrapper.querySelector('.brand-anchor-nav') ? navWrapper : null;
  }

  function updateOffsets() {
    const navWrapper = getNavWrapper();

    if (!navWrapper) {
      document.documentElement.style.removeProperty('--brand-anchor-nav-top');
      document.documentElement.style.removeProperty('--brand-anchor-scroll-margin');
      return;
    }

    const header = document.querySelector(selectors.header);
    const stickyHeaderHeight = header && header.classList.contains('site-header--stuck')
      ? header.offsetHeight
      : 0;
    const navHeight = navWrapper.offsetHeight;
    const anchorOffset = stickyHeaderHeight + navHeight + 24;

    document.documentElement.style.setProperty('--brand-anchor-nav-top', `${stickyHeaderHeight}px`);
    document.documentElement.style.setProperty('--brand-anchor-scroll-margin', `${anchorOffset}px`);
  }

  function updateBackToTopVisibility() {
    const button = document.querySelector(selectors.backToTopButton);
    const isDesktop = window.matchMedia('(min-width: 769px)').matches;

    if (!button) {
      return;
    }

    button.classList.toggle('is-visible', !isDesktop && window.scrollY > 300);
  }

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  function bindBackToTop() {
    const button = document.querySelector(selectors.backToTopButton);

    if (!button || button.dataset.initialized === 'true') {
      return;
    }

    button.dataset.initialized = 'true';
    button.addEventListener('click', scrollToTop);
  }

  function handleResize() {
    updateOffsets();
    updateBackToTopVisibility();
  }

  function detachWindowListeners() {
    if (!windowListenersAttached) return;

    window.removeEventListener('resize', handleResize);
    window.removeEventListener('scroll', updateBackToTopVisibility);
    windowListenersAttached = false;
  }

  function setupObservers() {
    const navWrapper = getNavWrapper();

    if (resizeObserver) {
      resizeObserver.disconnect();
    }

    if (mutationObserver) {
      mutationObserver.disconnect();
    }

    if (!navWrapper) {
      detachWindowListeners();
      updateOffsets();
      return;
    }

    if (!windowListenersAttached) {
      window.addEventListener('resize', handleResize);
      window.addEventListener('scroll', updateBackToTopVisibility, { passive: true });
      windowListenersAttached = true;
    }

    const header = document.querySelector(selectors.header);
    resizeObserver = new ResizeObserver(updateOffsets);
    resizeObserver.observe(navWrapper);

    if (header) {
      resizeObserver.observe(header);

      mutationObserver = new MutationObserver(updateOffsets);
      mutationObserver.observe(header, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    bindBackToTop();
    updateOffsets();
    updateBackToTopVisibility();
  }

  document.addEventListener('page:loaded', setupObservers);
  document.addEventListener('shopify:section:load', setupObservers);
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches(selectors.navWrapper) || event.target.querySelector(selectors.navWrapper)) {
      window.setTimeout(setupObservers, 0);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObservers);
  } else {
    setupObservers();
  }
})();
